// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".openChatDialog[data-v-63b875c4]  .customWidth{width:472px}.tipBuy[data-v-63b875c4]{font-size:12px;font-family:MicrosoftYaHei;color:#999}.tipBuy .Iconstyle[data-v-63b875c4]{width:16px;height:16px;float:left;margin-right:12px}", ""]);
// Exports
module.exports = exports;
